import { Typography } from "@mui/material";
import { Center } from "components/Center";
import { Placeholder } from "components/Placeholder";

export default function NotFoundPage() {
  return (
    <Center>
      <Typography align="center" variant="h1">404</Typography>
      <Placeholder>Page not found</Placeholder>
    </Center>
  )
}